import api from "@/lib/axios";
import { makeServerApiRequest } from "@/lib/server-api";
import { Pool, PoolSchema } from "@/models/pool";
import { isServer, QueryKey, queryOptions } from "@tanstack/react-query";

export const getPool = async ({
  poolId,
}: {
  poolId: string | null;
}): Promise<Pool | null> => {
  if (!poolId) return null;

  if (isServer) {
    try {
      const { data } = await makeServerApiRequest<Pool>(`/pools/${poolId}`);
      return PoolSchema.parse(data);
    } catch (error) {
      console.log("Server-side pool fetch error:", error);
      return null;
    }
  }

  const { data } = await api.get<Pool>(`/pools/${poolId}`);
  try {
    return PoolSchema.parse(data);
  } catch (error) {
    console.log(error);
    return null;
  }
};
export const getPoolQueryKey = (poolId: string | null): QueryKey => {
  return ["pool", poolId];
};

export const getPoolQueryOptions = (poolId: string | null) => {
  return queryOptions({
    queryKey: getPoolQueryKey(poolId),
    queryFn: () => getPool({ poolId }),
    refetchInterval(query) {
      if (query.state.data?.is_migrating) {
        return 1000 * 3;
      }
      return false;
    },

    enabled: !!poolId,
  });
};
